<template>
  <div class="main">
    <img
      class="img"
      v-if="!isXl"
      src="../assets/images/error-page.png"
      alt="unlucky"
    />
    <img
      class="img isXl"
      v-else
      src="../assets/images/no_trip.png"
      alt="unlucky"
    />

    <div class="text">{{ textTip.tip }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { BUSINESS_TYPE_XL } from '../constants/index';
const type = {
  1: {
    tip: '账号异常，暂时无法参与活动~',
    title: '账号异常'
  },
  2: {
    tip: '活动已下线',
    title: '活动下线'
  }
};
export default {
  computed: {
    ...mapState('app', ['businessType']),
    isXl() {
      return this.businessType == BUSINESS_TYPE_XL;
    },
    textTip() {
      return this.$route.params[type] || type[1];
    }
  },
  mounted() {
    document.title = this.textTip.title;
  }
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    width: 327px;
    margin-bottom: 70px;
    &.isXl {
      width: 360px;
    }
  }

  .text {
    font-size: 30px;
    color: #8c8c8c;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    font-weight: 400;
  }
}
</style>
